import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { loadOperatorAction } from 'src/actions/session';
import EstablishmentModal from '../EstablishmentModal';


class Establishment extends Component {

    constructor(props) {
        super(props);
        this.state = {
            show: false,
        };
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick(_event) {
        const { show } = this.state;
        this.setState({
            show: !show
        });
    }

    render() {
        const { show } = this.state;  
        const { operatorId, operators } = this.props;
        const operator = operators.find(op => op.id === operatorId);
        const { title } = operator || '';
        return (
            <Fragment>
                <EstablishmentModal show={show} handleClose={this.handleClick} />
                <a
                    href="javascript:void(0)"
                    className="h4 mb-0 text-white d-none d-lg-inline-block"
                    onClick={this.handleClick}>
                        <i className="fas fa-sync-alt mr-2 text-sm" />
                        {title}
                </a>
            </Fragment>
        );
    }

}

const mapStateToProps = (state) => ({
    operatorId: state.session.operatorId,
    operators: state.user.portalUser.operators,
    user: state.user
});

export default connect(mapStateToProps)(Establishment);


// WEBPACK FOOTER //
// ./src/components/Layout/Topbar/Establishment.js